import { lazy, Suspense } from "react";
import SiteHeader from "@/components/SiteHeader";
import BrandHero from "@/components/home/BrandHero";
import SiloEntryBlocks from "@/components/home/SiloEntryBlocks";
import { useSEO } from "@/hooks/useSEO";
import JsonLd from "@/components/JsonLd";

const FeaturedAutomationCategories = lazy(() => import("@/components/home/FeaturedAutomationCategories"));
const FeaturedBrands = lazy(() => import("@/components/home/FeaturedBrands"));
const FeaturedManufacturersSilo = lazy(() => import("@/components/home/FeaturedManufacturersSilo"));
const WhyNardySection = lazy(() => import("@/components/home/WhyNardySection"));
const HomeFAQ = lazy(() => import("@/components/home/HomeFAQ"));
const HomeBlogSection = lazy(() => import("@/components/HomeBlogSection"));
const FinalCTA = lazy(() => import("@/components/FinalCTA"));
const SiteFooter = lazy(() => import("@/components/SiteFooter"));

const SITE_URL = "https://nardyautomation.com";

const Index = () => {
  useSEO({
    title: "Nardy Automation — Industrial Automation Parts Supplier USA",
    description:
      "Industrial automation parts supplier: PLCs, HMIs, VFDs, servo drives, I/O and safety modules. US stock, fast worldwide shipping.",
    canonical: "/",
  });

  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "Nardy Automation",
    url: SITE_URL,
    logo: `${SITE_URL}/favicon.ico`,
    description:
      "Industrial automation parts supplier — PLCs, HMIs, VFDs, servo drives and communication modules. US inventory, worldwide shipping.",
    address: {
      "@type": "PostalAddress",
      addressLocality: "Windermere",
      addressRegion: "FL",
      addressCountry: "US",
    },
    areaServed: "Worldwide",
  };

  const websiteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "Nardy Automation",
    url: SITE_URL,
    potentialAction: {
      "@type": "SearchAction",
      target: `${SITE_URL}/shop?q={search_term_string}`,
      "query-input": "required name=search_term_string",
    },
  };

  return (
    <main>
      <JsonLd id="home-organization" data={organizationSchema} />
      <JsonLd id="home-website" data={websiteSchema} />
      <SiteHeader />
      <BrandHero />
      <SiloEntryBlocks />
      <div className="cv-auto-lg">
        <Suspense fallback={<div style={{ minHeight: 960 }} />}>
          <FeaturedAutomationCategories />
        </Suspense>
      </div>
      <div className="cv-auto-md">
        <Suspense fallback={<div style={{ minHeight: 720 }} />}>
          <FeaturedBrands />
        </Suspense>
      </div>
      <div className="cv-auto-lg">
        <Suspense fallback={<div style={{ minHeight: 960 }} />}>
          <FeaturedManufacturersSilo />
        </Suspense>
      </div>
      <div className="cv-auto-md">
        <Suspense fallback={<div style={{ minHeight: 720 }} />}>
          <WhyNardySection />
        </Suspense>
      </div>
      <div className="cv-auto-md">
        <Suspense fallback={<div style={{ minHeight: 720 }} />}>
          <HomeFAQ />
        </Suspense>
      </div>
      <div className="cv-auto-lg">
        <Suspense fallback={<div style={{ minHeight: 960 }} />}>
          <HomeBlogSection />
        </Suspense>
      </div>
      <div className="cv-auto-sm">
        <Suspense fallback={<div style={{ minHeight: 480 }} />}>
          <FinalCTA />
        </Suspense>
      </div>
      <Suspense fallback={<div style={{ minHeight: 400 }} />}>
        <SiteFooter />
      </Suspense>
    </main>
  );
};

export default Index;
